/**
 * Created by pwq on 2016/12/7.
 */

import apiRequest from '../../common/request'
import { message } from 'antd';

const PREFIX = "_ESSAY_LIST_";

export const RECEIVE_SHENLUN_AREAS = PREFIX + "RECEIVE_SHENLUN_AREAS";
export const REQUEST_QUESTIONS = PREFIX + "REQUEST_QUESTIONS";
export const RECEIVE_QUESTIONS = PREFIX + "RECEIVE_QUESTIONS";
export const SET_KEY_VALUE = PREFIX + "SET_KEY_VALUE";
export const RESET_FILTER_STATUS = PREFIX + "RESET_FILTER_STATUS";

export const setKeyValue = (key, value) => ({ type: SET_KEY_VALUE, key, value });

export const resetFilterStatus = () => ({ type: RESET_FILTER_STATUS });

function request_questions() {
    return {
        type: REQUEST_QUESTIONS
    }
}

function receive_questions(data) {
    return {
        type: RECEIVE_QUESTIONS,
        questionList: data.content,
        totalPages: data.totalPages,
        totalElements: data.totalElements,
        numberOfElements: data.numberOfElements,
        receiveAt: Date.now()
    }
}

/** 生成PDF */
export function createExercisePdf(examineId){
    let config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include'
    };   
    return apiRequest(`/gk/ops/shenlun/createPdf/${examineId}` , config)
            .then(json => {
                message.success('生成PDF成功')
            })
            .catch(error => console.log(error));
}

export function fetchQuestions(params, cb) {
    let data = params || {};
    let config = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        credentials: 'include'
    };

    return dispatch => {
        dispatch(request_questions());
        apiRequest('/gk/ops/shenlun/page', config)
            .then(json => {
                dispatch(receive_questions(json.obj));
                cb && cb();
            })
            .catch(error => console.log(error));
    }
}

function receive_shenlun_areas(areas){
    return {
        type: RECEIVE_SHENLUN_AREAS,
        areas
    }
}

/** 申论地区列表 */
export function fetchShenlunAreas(){
    let config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include'
    };
    return dispatch => {
      apiRequest('/gk/ops/shenlun/area', config)
        .then(json => {
            dispatch(receive_shenlun_areas(json.obj));
        })
        .catch(error => console.log(error));
    }
}